import React from 'react';
import { FileScan, Loader } from 'lucide-react';
import { BackButton } from '../../../common/BackButton';
import { useTranslation } from '../../../../contexts/I18nProvider';
import { useDocInterpretationAvailability } from '../../../../hooks/useDocInterpretationAvailability';

interface DocInterpretationGateProps {
  title: string;
  onBack?: () => void;
  children: React.ReactNode;
}

/**
 * Viser sidene for dokumenttolking bare for tenanter som har tabellene (migrasjon 127).
 * Menyene skjuler sidene allerede; dette fanger direktelenker (?module=…), så de ikke gir
 * databasefeil og en spinner som aldri stopper.
 */
export const DocInterpretationGate: React.FC<DocInterpretationGateProps> = ({ title, onBack, children }) => {
  const { t } = useTranslation();
  const availability = useDocInterpretationAvailability();

  if (availability.loaded && availability.installed) return <>{children}</>;

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="px-6 pt-4 pb-2 bg-white border-b">
        <div className="flex items-center space-x-4">
          <BackButton onClick={onBack || (() => {})} />
          <h1 className="text-2xl font-bold text-gray-800 flex items-center space-x-2">
            <FileScan size={24} />
            <span>{title}</span>
          </h1>
        </div>
      </div>
      {availability.loaded ? (
        <div className="m-6 p-4 bg-white border border-gray-200 rounded-lg text-sm text-gray-700">
          {t('manager.modules.docInterpretationSettings.notInstalled', {},
            'Dokumenttolking er ikke tatt i bruk for denne kunden. Kontakt IntegrasjonsPartner for å komme i gang.')}
        </div>
      ) : (
        <div className="flex items-center justify-center h-64"><Loader className="animate-spin" size={20} /></div>
      )}
    </div>
  );
};
